<template>
  <div>
    <div>
      <hooper class="main" :settings="hooperSettings">
        <slide
          class="slide w-56 hover"
          v-for="(slide, index) in productsByCategory"
          :key="index"
          :class="`slide--${index}`"
        >
          <router-link target="_blank" :to="{ name: 'product', params: { id: slide.id } }">
            <!-- <span v-if="slide.old_price > 0">
            <p class="font-medium line-through  text-red-500 float-right">{{ slide.old_price | formatNumber }}</p> -->
            <!-- <br> -->
            <!-- <p class="font-medium text-teal-400 text-lg">{{ slide.price | formatNumber }}</p>
            </span>
            <span v-else>
              <p class="font-medium float-right">{{ slide.price | formatNumber }}</p>
            </span> -->

            <div class="display-470">
  <img :src="slide.image" class="product-image imazh-size-470" />
</div>

            <!-- <img :src="slide.image" class="product-image sm:w-1/6 md:w-full lg:w-full" /> -->
            <div class="mt-2 display-470-teksti">
              <!-- <p class="text-sm text-center">{{ slide.name.substring(0,135)+"..." }}</p> -->
              <p class="text-sm text-center new-text-size">{{ slide.name }}</p>
               
              <div v-if="slide.old_price > 0" class="text-center">
             <span class="font-medium text-teal-400 text-lg text-center pr-2 new-text-size2">{{ slide.price | formatNumber }}</span>
            <!-- <br> -->
            <span class="font-medium line-through  text-red-500 new-text-size2">{{ slide.old_price | formatNumber }}</span>
            </div>
            <div v-else>
              <p class="font-medium text-center new-text-size2">{{ slide.price | formatNumber }}</p>
            </div>
            <br>
              <!-- <div class="px-10 yje-400">
                <StarRating
                  class=""
                  :show-rating="false"
                  :star-size="20"
                  :read-only="true"
                  v-model="slide.ratings">
                </StarRating>
              </div> -->
            </div>
          </router-link>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
      </hooper>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
// import StarRating from "vue-star-rating";

export default {
  props: {
    productsByCategory: Array,
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    // StarRating
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 6,
        centerMode: false,
        breakpoints: {
          320: {
            itemsToShow: 1,
          },
          360: {
            itemsToShow: 1,
          },
          375: {
            itemsToShow: 1,
          },
          400: {
            itemsToShow: 1,
          },
          411: {
            itemsToShow: 1,
          },
          414: {
            itemsToShow: 1,
          },
          768: {
            itemsToShow: 4,
          },
          1024: {
            itemsToShow: 6,
          },
        },
      },
    };
  },
};
</script>

<style scoped>

.hover{
  margin-bottom: 20px;
}
.hover:hover{
  box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.08);
}

.new-text-size2{
  font-size: 16px;
}
.main {
  /* margin-bottom: 30px; */
  width: 1250px;
  height: 100%
}





/* @media (max-width: 1024px) {
  .main {
    width: 1000px;
    height: 100%;
  }
} */

.slide {
  padding: 12px;
}

.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  transition-duration: 0.3s;
}

.thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.thumbnails .agile__nav-button--prev {
  left: -45px;
}

.thumbnails .agile__nav-button--next {
  right: -45px;
}

.agile__nav-button:hover {
  color: #888;
}

.agile__dot {
  margin: 0 10px;
}

.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
}

.agile__dot--current button,
.agile__dot:hover button {
  background-color: #888;
}

img.product-image .agile__track {
  transform: translate(0px) !important;
}
.new-text-size{
  display: -webkit-box;
      -webkit-line-clamp: 2; /* Limit to two lines */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 10px;
}

@media (max-width: 768px) {
  .main {
    width: 700px;
    height: 100%;
  }
}

@media(max-width:470px){
  .display-470-teksti{
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;

    justify-content: center;
    align-items: center;
  }
.new-text-size{
  font-size: 10px;
  width: 70%;
}

.hover{
  margin-bottom: 0;
}

.imazh-size-470{
  width: 70%;
}

.display-470{
  display: flex;
  justify-content: center;
}

}

@media (min-width: 414px) and (max-width: 450px) {
  .main {
    height: 100%;
    width: 415px;
  }
  .hooper-prev{
    top:40% !important;
  }
}

@media (max-width: 320px) {
  .main {
    width: 300px;
    height: 100%;
  }
}

@media (max-width: 360px) {
  .main {
    width: 300px;
    height: 100%;
  }
}

@media (max-width: 375px) {
  .main {
    width: 300px;
    height: 100%;
  }
}

@media(max-width:450px){
  .yje-400{
    margin-top: -25px;
    margin-left:110px;
  }
}


@media(max-width:414px){
  .yje-400{
    margin-top: -25px;
    margin-left:50px;
  }
}

@media (max-width: 411px) {
  .main {
    width: 300px;
    height: 100%;
  }
}
/* 
@media(min-width:414px) and (max-width:450px){
  .main {
    width: 300px;
    height: 100%;
  }
} */

@media (max-width: 414px) {
  .main {
    width: 300px;
    height: 100%;
  }
}

</style>
